export default __webpack_public_path__ + "static/media/heading-block-thumbnail-light.ae80b12a.svg";